import React from "react";
import Carousel from "react-elastic-carousel";
import Item from "./Item";
import "./Cursor.css";
import Femme from '../images/femme1.jpg'
import Femme2 from '../images/femme2.jpg'
import Men1 from '../images/men1.jpg'
import Enfant1 from '../images/enfant1.jpg'
import Chaussures1 from '../images/Chauss1.jpg'
import Chaussures2 from '../images/Chaussures2.jpg'
import Gunts1 from '../images/Guants1.jpg';
import Chaussette from '../images/Chausset1.jpg';
import Men3 from '../images/men3.jpg';
import { v4 as uuidv4 } from "uuid";

const items = [
  {
    id: uuidv4(),
    name: Chaussette,
    text: 'Chaussettes',
  },
  {
    id: uuidv4(),
    name: Femme,
    text: 'Musulmans',
  },
  {
    id: uuidv4(),
    name: Femme2,
    text: 'Africaine',
  },
  {
    id: uuidv4(),
    name: Men1,
    text: 'Jeunes',
  },
  {
    id: uuidv4(),
    name: Enfant1,
    text: 'Enfants',
  },
  {
    id: uuidv4(),
    name: Chaussures1,
    text: 'Jordan',
  },
  {
    id: uuidv4(),
    name: Chaussures2,
    text: 'Air Force',
  },
  {
    id: uuidv4(),
    name: Gunts1,
    text: 'Guants',
  },
  {
    id: uuidv4(),
    name: Men3,
    text: 'Africain',
  },
];


const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 3 },
];



function Cursor() {
  return (
    <>
      <div style={{ textAlign: "center" }}>
         <h1>Vous pouvez trouver aussi chez nous</h1>
         <tr />
         <i class="fas fa-arrow-down fa-2x"></i>
      </div>
      <div className="Cursor">
        <Carousel breakPoints={breakPoints}>
          {items.map(item => (
            <Item className="itm" key={item.id}>
                <img src={item.name} className='ImageItm'/>
                <span className="text">
                    {item.text}
                </span>
            </Item>
          ))}
        </Carousel>
      </div>
    </>
  );
}

export default Cursor;
